import React from "react"
import PropTypes from "prop-types"
import { compose, withPropsOnChange } from "recompose"
import filter from "lodash/filter"

import { Flex, Box } from "@infotech/uikit-grid"

import Modal from "./components/Modal"
import { getIssueByEvent } from "./api/entities/issue"
import { getSapIssueIdByEvent } from "./api/entities/sap"
import withApiTransport from "./api/apiTransport"
import SecondaryInfo from "./SecondaryInfo"
import Plan from "./Plan"
import styles from "./styles.css"

const prepareResousers = resourcesData =>
  filter(resourcesData, resourceItem => resourceItem.resourceTypeId === 2)

const enhance = compose(
  withPropsOnChange([`eventData`], ({ eventData: { uuid } = {} }) => ({
    payload: uuid,
    load: getIssueByEvent,
    propName: `issue`,
  })),
  withApiTransport,

  withPropsOnChange([`eventData`], ({ eventData: { uuid } = {} }) => ({
    payload: uuid,
    load: getSapIssueIdByEvent,
    propName: `sapIssueId`,
  })),
  withApiTransport,
  withPropsOnChange([`resourcesData`], ({ resourcesData }) => ({
    humanResources: prepareResousers(resourcesData),
  })),
)

const EventConnectedInfo = ({
  eventData,
  issue,
  sapIssueId,
  humanResources,
  modalProps,
}) => (
  <Box br className={styles[`main-container`]}>
    <Flex column>
      <SecondaryInfo issue={issue} sapIssueId={sapIssueId} />
      <div className={styles.br} />
      <Plan
        issue={issue}
        sapIssueId={sapIssueId}
        eventData={eventData}
        humanResources={humanResources}
        modalProps={modalProps}
      />
    </Flex>
  </Box>
)

EventConnectedInfo.propTypes = {
  eventData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    startDateTime: PropTypes.number.isRequired,
    endDateTime: PropTypes.number.isRequired,
  }).isRequired,
  modalProps: PropTypes.shape({
    SIDEBAR_WIDTH: PropTypes.number.isRequired,
    SIDEBAR_COMPACT_WIDTH: PropTypes.number.isRequired,
    isMenuVisible: PropTypes.bool.isRequired,
    areMenuCaptionsVisible: PropTypes.bool.isRequired,
  }),
}

EventConnectedInfo.defaultProps = {
  modalProps: {
    SIDEBAR_WIDTH: 259,
    SIDEBAR_COMPACT_WIDTH: 56,
    isMenuVisible: true,
    areMenuCaptionsVisible: false,
  },
}

export { Modal }

export default enhance(EventConnectedInfo)
